import script from "./Backers.vue?vue&type=script&setup=true&lang=ts"
export * from "./Backers.vue?vue&type=script&setup=true&lang=ts"

import "./Backers.vue?vue&type=style&index=0&id=03766986&scoped=true&lang=css"
import "./Backers.vue?vue&type=style&index=1&id=03766986&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03766986"]])

export default __exports__